export const getProductUrl = (config, id) => {
	const items = [
		...(config?.header?.otherResources?.products ?? []),
		...(config?.header?.otherResources?.modules ?? []),
	];
	return items.find(item => item.id === id)?.url || "";
};

export const getProductLinks = config => ({
	analyticsLink: getProductUrl(config, "wb"),
	ihLink: getProductUrl(config, "ih"),
	khLink: getProductUrl(config, "kh"),
	dmLink: getProductUrl(config, "dm"),
	assetHubLink: getProductUrl(config, "eh"),
	landingUrl: getProductUrl(config, "landing"),
});
